'use client';

import {useEffect} from 'react';
import {useRouter} from 'next/navigation';
import {GlobalEventEmitter} from '@sdk-mobile';

export default function GlobalSubscriptions({gid}: {gid: string}) {
  const router = useRouter();

  useEffect(() => {
    const switchTabSubscription = GlobalEventEmitter.addListener('switchToTab', (tab: string) => {
      switch (tab) {
        case 'PLAY':
          return router.replace(`/games/${gid}/home`);
        case 'STORE':
          return router.push(`/games/${gid}/store`);
        default:
          console.log('WebSDK: switchToTab() MOCK USED');
      }
    });

    const popToHomeSubscription = GlobalEventEmitter.addListener('PopToHome', () => {
      router.replace(`/games/${gid}/home`);
    });

    return () => {
      switchTabSubscription.remove();
      popToHomeSubscription.remove();
    };
  }, [gid, router]);

  return null;
}
